/*@flow*/
/** @jsx jsx */
// @ts-check
import { jsx } from '@emotion/core';
import { useEffect } from 'react';
import waitTill from 'lib/waitTill';

export function useDomSync() {
  useEffect(() => {
    waitTill(() => {
      const node = document.querySelector('.top-navbar');
      return node && node.offsetHeight > 0;
    }).then(() => {
      const nav = document.querySelector('.top-navbar');
      const site = document.querySelector('article#site');
      if (nav && site) {
        const navHeight = nav.offsetHeight;
        site.style.height = `calc(100% - ${navHeight}px)`;
      }
    });

    waitTill(() => document.readyState === 'complete' && window.cityMap).then(
      () => window.cityMap.invalidateSize()
    );
  }, []);
}
